<template lang="pug">
  main
    NavBarSoporte
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title {{ areaStr }}
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-2
            .field
              input#checkOtro.is-checkradio(type='checkbox' value='' v-model='otroEquipo')
              label.is-size-6(for='checkOtro') Equipos en el área
          .column.is-6(v-show="verAreas_OE")
            input#ticketSis.is-checkradio.is-black(type='radio', value='3' v-model='area')
            label.is-size-6(for='ticketSis') Sistemas
            input#ticketIns.is-checkradio.is-black(type='radio', value='1' v-model='area')
            label.is-size-6(for='ticketIns') Instrumentación
        .columns
          .column.is-6
            .field
              label.label {{ tituloBusqueda }}
              .control
                typeahead(:options="articulosShow" :optionSelect="itemSel" :tema="type" v-model="itemSel")
          .column.is-6(:class="classOtroEquipo")
            .field
              label.label Descripción del Problema {{ txtRestante }}
              .control
                textarea.textarea.is-dark(placeholder='Descripción del Problema' v-model="problema")
        .columns
          .column.is-one-third
            a.button.is-black.is-block(@click="checkForm") Guardar
        .columns(v-show="datosFaltantes.length > 0")
          .column.is-12
            .notification
              button.delete(@click="borrarNotificacion")
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns.column-blanco
</template>


<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarSoporte from '@/components/soporte_Componentes/NavBarSoporte.vue'
import { mapState } from 'vuex'
import InventarioServices from '../../services/inventario/inventario'
import usuariosServices from '../../services/usuarios/usuarios'
import ticketServices from '@/services/soporte/tickets'
import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'
import moment from 'moment'

  export default {
    name: 'NuevoTicket',
    components: { Loader, NavBarSoporte, Typeahead },
    data() {
      return {
        isLoading: true,
        area: '',
        ubicacion: '',
        idSolicita: '',
        solicita: '',
        atiende: '',
        serie: '',
        modelo: '',
        oficina: '',
        usuarios: [],
        usuariosArea: [],
        departamento: '',
        problema: null,
        tituloBusqueda: '',
        txtRestante: '',
        userAtiende: {},
        jefeArea: {},
        otroEquipo: false,
        articulosAsignados: [],
        tipos: [],
        tiposArea: [],
        articulosShow: [],
        itemSel: {},
        type: '',
        marcas: [],
        typeTipo: 'tipos',
        typeMarca: 'marca',
        classOtroEquipo:'is-6',
        verAreas_OE: true,
        datosFaltantes: []
      }
    },
    watch: {
      problema () {
        this.getRestante()
      },
      ubicacion () {
        this.obtenerUser_Atiende()
      },
      otroEquipo () {
        this.cambiarTitulo()
      },
      area () {
        this.tiposArea.length = 0
        if (this.area === '1') {
          this.tiposArea = this.tipos.filter( cat => cat.area === 'i')
        } else {
          this.tiposArea = this.tipos.filter( cat => cat.area === 's')
        }
        this.obtenerUser_Atiende()
      }
    },
    methods: {
      iniciarComponente() {
        if (this.area_soporte === 'I') {
          this.areaStr = 'Soporte Instrumentación y Control '
          this.sitios = this.oficinasI
          this.area = '1'
        } else {
          this.areaStr = 'Soporte Sistemas y Telec. '
          this.sitios = this.oficinasS
          this.area = '3'
        }
        this.obtenerArticulosAsignados()
      },
      obtenerArticulosAsignados () {
        InventarioServices.getAsignacion_Usuario(this.userLogin.id, 'R')
          .then( res => {
            this.articulosAsignados = res.map(this.convertirArticulos)
            if (this.articulosAsignados.length === 0) {
              this.otroEquipo = true
              
            }
            this.obtenerArticulosOficina()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },
      convertirArticulos (art) {
        let texto = ''
        switch (true) {
          case art.marca === '' && art.modelo === '' && art.serie === '':
            texto =  `${art.categoria} - ${art.subcategoria}`
            break
          case art.marca === '' && art.modelo !== '' && art.modelo === '':
            texto =  `${art.categoria} - ${art.subcategoria} | ${art.modelo}`
            break
          case art.marca !== '' && art.modelo === '' && art.modelo === '':
            texto =  `${art.categoria} - ${art.subcategoria} | ${art.marca}`
            break
          case art.marca === '' && art.modelo === '' && art.serie !== '':
            texto =  `${art.categoria} - ${art.subcategoria} ~ Serie: ${art.serie}`
            break
          case art.marca === '' && art.modelo !== '' && art.modelo === '' && art.serie !== '':
            texto =  `${art.categoria} - ${art.subcategoria} | ${art.modelo} ~ Serie: ${art.serie}`
            break
          case art.marca !== '' && art.modelo === '' && art.modelo === '' && art.serie !== '':
            texto =  `${art.categoria} - ${art.subcategoria} | ${art.marca} ~ Serie: ${art.serie}`
            break
          default:
            texto =  `${art.categoria} - ${art.subcategoria} | ${art.marca} - ${art.modelo} ~ Serie: ${art.serie}`
            break
        }

        return {
          ...art,
          text: texto,
          estado: parseInt(art.estado)
        }
      },
      obtenerArticulosOficina () {

        InventarioServices.getArticulosOficina(this.userLogin.oficina)
          .then(res => {
            console.log(res)
            this.tipos = res.map(this.convertirArticulos)
            this.tiposArea = this.tipos
            this.obtenerUsuarios()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      obtenerUsuarios () {
        usuariosServices.getUsuarios_SeI()
          .then(res => {
            console.log(res)
              let usuariosSel = res.filter(user => user.id !== '1538165924968')
              this.usuarios = usuariosSel
              this.idSolicita = this.userLogin.id
              this.isLoading = false
              this.obtenerUser_Atiende()
          })
      },
      
      getRestante () {
        if (this.problema) {
          this.txtRestante = `(${this.problema.length}/500)`
        } else {
          this.txtRestante = '(0/500)'
        }
      },
      checkForm () {
        this.datosFaltantes = []
        if (Object.keys(this.itemSel).length > 0 && this.problema) {
          this.saveTicket()
        } else {
          if (Object.keys(this.itemSel).length == 0) {
            this.datosFaltantes.push('El equipo es requerido.')
          }

          if (!this.problema) {
            this.datosFaltantes.push('La descripción del problema es requerido')
          }
        }
      },
      saveTicket() {
        this.isLoading = true
        
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        let equipo
        if (this.itemSel.subcategoria === '') {
          equipo = `${this.itemSel.categoria}`
        } else {
          equipo = `${this.itemSel.categoria} - ${this.itemSel.subcategoria}`
        }

        ticketServices.saveTicket(fechaReg, this.itemSel.id, equipo, this.itemSel.marca, this.itemSel.modelo, this.itemSel.serie, this.area, this.itemSel.ubicacion, this.departamento, this.itemSel.oficina, this.idSolicita, this.solicita, this.problema, '0')
          .then(res => {
            if (res.success) {
              let idTicket = res.getData
              //RegistrarAtends 
              ticketServices.saveAtends(idTicket, this.jefeArea.id, this.jefeArea.usuario)
                .then((dataJA) => {

                  if (dataJA.success) {
                    let i=0
                    this.userAtiende.forEach(element => {
                      ticketServices.saveAtends(idTicket, element.id, element.usuario)
                        .then(resA => {
                          console.log(resA)
                          if (resA.success) {
                            i++ 
                            if (this.userAtiende.length == i) {
                              this.displayToast('El ticket ha sido guardado.', 'done', 'OK')
                              this.$router.push('/Soporte')
                            } else {
                              console.log(`Guardados ${i} atiende.`)
                            }
                          } else {
                            this.displayToast(resA.respuesta, 'ban', 'OK')
                          }
                        })
                        .catch((e3) => {
                          this.isLoading = false
                          this.displayToast(e3.message, 'ban', 'OK')
                        })
                    })
                  } else {
                    this.isLoading = false
                    this.displayToast(resA.respuesta, 'ban', 'OK')
                  }

                  
                })
                .catch((eJA)=> {
                  this.isLoading = false
                  this.displayToast(eJA.message, 'ban', 'OK')
                })

              
              
            } else {
              this.displayToast(res.respuesta, 'ban', 'OK')
            }
          })
          .catch(e1 => {
            this.isLoading = false
            this.displayToast(e1.message,'ban', 'OK')
          })
      },
      
      obtenerUser_Atiende () {
        
        let usuarios_atender = []
        if (this.userLogin.ubicacion === 'CORP') {
          this.usuariosArea = this.usuarios.filter( user => user.departamento === this.area)
          this.jefeArea = this.usuariosArea.find( user => user.categoria === '2' )
          usuarios_atender = this.usuarios.filter(user => user.ubicacion === 'CORP')
        } else {
          this.usuariosArea = this.usuarios.filter( user => user.departamento === this.area && user.categoria === '3')
          this.jefeArea = this.usuarios.find( user => user.categoria === '2' && user.departamento === this.area)
          usuarios_atender = this.usuariosArea
        }

        switch (this.userLogin.ubicacion) {
          case 'TPA':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'TPA' && parseInt(user.estatus) > 0 )
            break
          case 'CORP':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'CORP' && parseInt(user.estatus) > 0 )
            break
          case 'IRGE':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'IRGE' && parseInt(user.estatus) > 0)
            break
          case 'EB00':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'TPA' && parseInt(user.estatus) > 0)
            break
          case 'EB01':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'LPG_DUCTO' && parseInt(user.estatus) > 0 || user.ubicacion === 'EB04' && parseInt(user.estatus) > 0)  
            break
          case 'EB02':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'LPG_DUCTO' && parseInt(user.estatus) > 0 || user.ubicacion === 'EB04' && parseInt(user.estatus) > 0)  
            break
          case 'EB03':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'LPG_DUCTO' && parseInt(user.estatus) > 0 || user.ubicacion === 'EB04' && parseInt(user.estatus) > 0)  
            break
          case 'EB04':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'IRGE' && parseInt(user.estatus) > 0 )
            break
          case 'ERM':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'IRGE' && parseInt(user.estatus) > 0 )
            break
          case 'LPG_DUCTO':
            this.userAtiende = usuarios_atender.filter( user => user.ubicacion === 'LPG_DUCTO' && parseInt(user.estatus) > 0 || user.ubicacion === 'EB04' && parseInt(user.estatus) > 0)  
            break
        
          default:
            break
        }
        this.cambiarTitulo()
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, {
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      borrarNotificacion() {
        this.datosFaltantes = []
      },
      cambiarTitulo () {
        console.log('Here')
        if (this.otroEquipo) {
          this.tituloBusqueda = 'Seleccione un equipo de su oficina'
          this.classOtroEquipo = 'is-6'
          this.articulosShow = this.tiposArea
        } else {
          this.tituloBusqueda = 'Seleccione uno de los equipos asignados'
          this.classOtroEquipo = 'is-6'
          this.articulosShow = this.articulosAsignados
        }
      },
      backPage() {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
      // this.obtenerDataTipos()
      this.getRestante()
      this.idSolicita = this.userLogin.id
      this.solicita = this.userLogin.nombre
      this.ubicacion = this.userLogin.ubicacion
      this.departamento = this.userLogin.departamento
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'area_soporte'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  .field.check-is-bottom {
    margin-top: 35px;
  }
</style>


// WEBPACK FOOTER //
// src/components/soporte_Componentes/NuevoTicket.vue